<div *ngIf="groupedDocuments; else noDocuments">
  <div class="row">
    <div class="col-4">
      <h3><ng-content></ng-content></h3>
    </div>
  </div>
  <div>
    <div *ngFor="let group of groupedDocuments">
      <div class="row" *ngIf="showInGroups">
        <div
          class="col-4 bold document-category-label"
          *ngIf="!group?.hideCategoryLabel"
          [innerHTML]="getDoclistLabel(group, categoryLabel)"
        ></div>
      </div>
      <!-- <div class="row" *ngIf="group.optOutLabel">* {{ group.optOutLabel }}</div> -->
      <div class="row" *ngIf="showColumnHeadings">
        <div class="header bold">Document Type</div>
        <div class="header bold">Title</div>
      </div>

      <ng-container *ngIf="!group.optOut">
        <div class="row documentContainer" *ngFor="let document of group.documents; let i = index">
          <div class="document-type-wide">
            {{ document.documentType || formatDocumentCategory(document.documentCategory) }}
          </div>
          <!-- <div class="file-name no-overflow"></div> -->
          <div class="col-1">
            <a
              matTooltip="Display file in new window"
              matTooltipPosition="right"
              class="preview"
              (click)="onViewBlob(document.key)"
              [attr.data-cy]="'preview_' + i"
              aria-label="“Display document"
            >
              {{ document.name }}
            </a>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="group.optOut">
        <div class="row documentContainer">
          <div class="document-type-optout">
            {{ formatDocumentCategory(group.category) }}
          </div>
          <!-- <div class="file-name no-overflow">&nbsp;</div> -->
          <div class="col-1" class="notProvided">Document not provided</div>
        </div></ng-container
      >
    </div>
  </div>
</div>

<ng-template #noDocuments>
  <div class="row">
    <div class="col-4">
      <h3>Documents</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-4">No documents available.</div>
  </div>
</ng-template>
